"use client";

import createIcon from './util/createIcon';
export default createIcon('M14 16.94V12.94H5.08L5.05 10.93H14V6.94L19 11.94Z', 'ArrowRightThin');